import { memo } from "react";
import { Heading } from "@stubhub/broadway-web";
import { FestivalIcon } from "@stubhub/broadway-web/icons/functional";
import type { EventListGridItem } from "src/http/types";
import { useFormattedContent } from "src/shared/components/content";
import { PerformerCarouselModule } from "src/website-apps/responsive/stubhub-performer/components/recently-viewed-events/PerformerCarouselModule";
import {
  CarouselId,
  CarouselItemType,
} from "src/website-apps/shared/components/carousel-module/carousel-analytics-event";
import { festivalCarouselContainer } from "./festival-carousel.recipe";
import { FestivalEventItem } from "./festival-event-item";

interface FestivalCarouselModuleProps {
  festivals: readonly EventListGridItem[];
  performerName: string;
}

const FestivalCarouselModuleComponent = ({ festivals, performerName }: FestivalCarouselModuleProps) => {
  const heading = useFormattedContent("cid$#4425452#", [performerName]);

  if (festivals.length === 0) return null;

  return (
    <div className={festivalCarouselContainer}>
      <PerformerCarouselModule<EventListGridItem>
        carouselId={CarouselId.FestivalFeaturedEvents}
        getItemKey={(event) => String(event.eventId)}
        header={
          <>
            <FestivalIcon size={16} />
            <Heading as="h2" color="text" size="medium" variant="title">
              {heading}
            </Heading>
          </>
        }
        itemType={CarouselItemType.Event}
        items={festivals}
        renderItem={(event, index, onItemClick) => (
          <FestivalEventItem event={event} position={index} onItemClick={onItemClick} />
        )}
        variant="plain"
      />
    </div>
  );
};

export const FestivalCarouselModule = memo(FestivalCarouselModuleComponent);
FestivalCarouselModule.displayName = "FestivalCarouselModule";
